export const allAggById = new Map();

export function getAllAgg(isLive, sportId) {
    return allAggById.get(`${isLive ? 'lv' : 'pr'}_${sportId}`);
}
